import { useState, useRef, useEffect, useCallback, Fragment } from "react"
import { Drawer, Button, Badge, Popover, Typography, Tooltip, Popconfirm } from "@arco-design/web-react"
// import useNavigateTo from "@/utils/useNavigateTo"
import { useNavigate } from "react-router-dom"
import emptyImg from "@/assets/create-space/material-empty.png"

import {
  IconNotification,
  IconCheckCircle,
  IconCheck,
  IconDelete,
  IconDoubleDown,
  IconDoubleUp,
} from "@arco-design/web-react/icon"
import noticeTitleIcon from "@/assets/notice_title_icon.png"
import "./index.less"
import { list, unreadCount, markRead, markReadAll, del, delAll } from "@/services/notice"

const ButtonGroup = Button.Group
const typeList = [
  {
    label: "授权过期",
    value: 1,
    url: "/account-auth", //账号授权管理页面
  },
]
const messageTabs = [
  {
    label: "全部",
    value: 0,
  },
  {
    label: "未读",
    value: 1,
  },
  {
    label: "已读",
    value: 2,
  },
]
const PAGE_SIZE = 10 // 每页显示的消息数量

function index() {
  const navigateTo = useNavigate()
  //未读条数
  const [unreadNum, setUnreadNum] = useState(0)
  const [visible, setVisible] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [page, setPage] = useState(1)
  const [messageList, setMessageList] = useState([])
  const [loading, setLoading] = useState(false)
  const [hasMore, setHasMore] = useState(true)
  const loaderRef = useRef<HTMLDivElement>(null)

  // api
  //未读数
  const getUnreadCount = () => {
    unreadCount().then(res => {
      setUnreadNum(res.data?.count || 0)
    })
  }

  const fetchMessages = useCallback(async (page: number, is_read: number) => {
    setLoading(true)
    const res = await list({ is_read, page, page_size: PAGE_SIZE })
    const newItems = res.data?.items || []
    setLoading(false)
    setHasMore(newItems.length == PAGE_SIZE)

    if (page === 1) {
      setMessageList(newItems)
    } else {
      setMessageList(prev => [...prev, ...newItems])
    }
  }, [])

  useEffect(() => {
    getUnreadCount()
  }, [])

  useEffect(() => {
    if (!visible) return
    const rootEl = document.querySelector(".arco-drawer-content")
    if (!rootEl || !loaderRef.current) return
    const io = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting && !loading && hasMore) {
          const nextPage = page + 1
          setPage(nextPage)
          fetchMessages(nextPage, messageTabs[currentIndex].value)
        }
      },
      {
        root: rootEl,
        rootMargin: "100px",
        threshold: 0,
      }
    )

    io.observe(loaderRef.current)
    return () => io.disconnect()
  }, [visible, page, loading, hasMore, currentIndex, fetchMessages])

  useEffect(() => {
    if (visible) {
      console.log("visible", "currentIndex", currentIndex)

      setPage(1)
      setHasMore(true)
      setMessageList([])
      fetchMessages(1, messageTabs[currentIndex].value)
    }
  }, [visible, currentIndex, fetchMessages])

  //按钮tab
  const buttonRender = (
    e: {
      label: string
      value: number
    },
    i: number
  ) => {
    return (
      <Button
        style={{ background: currentIndex === i ? "#fff" : "#f2f3f5" }}
        key={i}
        onClick={() => {
          setCurrentIndex(i)
          setHasMore(true)
        }}
        type={currentIndex === i ? "text" : "default"}
      >
        {e.label}
      </Button>
    )
  }
  //全部操作
  const moreMessagePopoverRender = (
    <div className="notice_more_message_popver">
      <Popconfirm
        focusLock
        title="提示"
        content="是否确认标记所有为已读?"
        position="br"
        onOk={() => {
          markReadAll().then(res => {
            getUnreadCount()
            //更新列表的已读数据
            setMessageList(prev => prev.map(item => ({ ...item, is_read: 2 })))
          })
        }}
      >
        <div className="notice_more_message_popver_item">
          <IconCheckCircle style={{ fontSize: "20px", marginRight: "10px" }} />
          标记所有为已读
        </div>
      </Popconfirm>
      <Popconfirm
        focusLock
        title="提示"
        content="是否删除所有已读消息?"
        position="br"
        onOk={() => {
          delAll().then(res => {
            getUnreadCount()
            setMessageList(prev => prev.filter(item => item.is_read !== 2))
          })
        }}
      >
        <div className="notice_more_message_popver_item">
          <IconDelete style={{ fontSize: "20px", marginRight: "10px" }} />
          删除所有已读消息
        </div>
      </Popconfirm>
    </div>
  )

  return (
    <div>
      <Badge
        count={unreadNum}
        style={{ cursor: "pointer" }}
        onClick={() => {
          setVisible(true)
        }}
      >
        <IconNotification style={{ fontSize: "22px" }} />
      </Badge>
      <Drawer
        width={555}
        title={
          <span className="notice_title">
            <img src={noticeTitleIcon} alt="" />
            消息提醒{" "}
          </span>
        }
        visible={visible}
        unmountOnExit
        onCancel={() => {
          setVisible(false)
          setCurrentIndex(0)
        }}
        footer={null}
      >
        <div className="notice_message_drawer">
          <div className="notice_message_tabs">
            <div className="notice_button_wrap">
              <ButtonGroup>
                {messageTabs.map((e, i) => {
                  return i === 1 ? (
                    <Badge count={unreadNum} key={e.value} style={{ cursor: "pointer" }}>
                      {buttonRender(e, i)}
                    </Badge>
                  ) : (
                    <Fragment key={e.value}>{buttonRender(e, i)}</Fragment>
                  )
                })}
              </ButtonGroup>
            </div>
            <Popover position="br" style={{ maxWidth: "fit-content" }} content={moreMessagePopoverRender}>
              <div className="notice_more_message_icon">...</div>
            </Popover>
          </div>
          <div className="notice_message_bottom_content">
            {messageList.length > 0 ? (
              <>
                <div className="notice_message_list">
                  {messageList.map(item => (
                    <div
                      key={item.id}
                      className="notice_message_list_item"
                      onClick={e => {
                        // e.stopPropagation()
                        //跳转到相应的页面
                        // window.open(url, "_blank")
                        setVisible(false)
                        navigateTo(typeList.find(e => e.value === item.type)?.url)
                        markRead(item.id).then(() => {
                          getUnreadCount()
                        })
                      }}
                    >
                      <div className="notice_message_list_item_header">
                        <div className="notice_message_list_item_header_left">
                          {item.is_read == 1 ? <div className="iseRead"></div> : null}
                          {`【${typeList.find(e => e.value == item.type)?.label}】`}
                        </div>
                        <div className="notice_message_list_item_header_right_box">
                          <TooltipDelay
                            render={() => (
                              <div className="notice_message_list_item_header_right">
                                <IconCheck
                                  style={{ color: item.is_read == 2 ? "#999" : "#3d3d3d" }}
                                  onClick={e => {
                                    e.stopPropagation()
                                    if (item.is_read == 2) return
                                    // messageRead(id)
                                    markRead(item.id).then(() => {
                                      getUnreadCount()
                                      setMessageList(prev => {
                                        return prev.map(e => {
                                          if (item.id === e.id) {
                                            e.is_read = 2
                                          }
                                          return e
                                        })
                                      })
                                    })
                                  }}
                                />
                              </div>
                            )}
                            content={"标记为已读"}
                            style={{ marginRight: 8 }}
                          />
                          <TooltipDelay
                            render={() => (
                              <div className="notice_message_list_item_header_right">
                                <IconDelete
                                  onClick={e => {
                                    e.stopPropagation()
                                    del(item.id).then(() => {
                                      getUnreadCount()
                                      setMessageList(prev => prev.filter(e => item.id !== e.id))
                                    })
                                  }}
                                />
                              </div>
                            )}
                            content={"删除"}
                          />
                        </div>
                      </div>
                      <div className="notice_message_list_item_content">
                        {/* text字段，type不通可能不一样 */}
                        {<TextEllipsis text={JSON.parse(item.content)?.text} />}
                      </div>
                      <div className="notice_message_list_item_time">{item.create_time}</div>
                    </div>
                  ))}
                </div>
                {/* 触底指示器 */}
                <div ref={loaderRef} style={{ height: 40, textAlign: "center" }} className="notice_message_list_loader">
                  {loading && "加载中..."}
                  {/* {!hasMore && messageList.length > 0 && "已加载全部"} */}
                </div>
              </>
            ) : (
              <div
                className="notice_message_list_empty-text"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "absolute",
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0,
                  fontSize: 14,
                }}
              >
                <img src={emptyImg} style={{ width: "60px" }} />
                <div style={{ marginTop: 8 }}>暂无数据</div>
              </div>
            )}
          </div>
        </div>
      </Drawer>
    </div>
  )
}

//延迟显示
const TooltipDelay = ({ render, content, style = {} }) => {
  const [visible, setVisible] = useState(false)
  const timerRef = useRef<number | null>(null)
  const handleMouseEnter = () => {
    timerRef.current = window.setTimeout(() => setVisible(true), 3000)
  }

  const handleMouseLeave = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
    setVisible(false)
  }
  return (
    <span onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={style}>
      <Tooltip mini position="top" trigger="hover" content={content} popupVisible={visible}>
        {render()}
      </Tooltip>
    </span>
  )
}

//文本省略号展开收起
const TextEllipsis = props => {
  const [expanded, setExpanded] = useState(false)
  const expandRender = (expanded: boolean) => {
    if (!expanded) {
      return (
        <span
          className="text-ellipsis-expand"
          onClick={e => {
            e.stopPropagation()
            setExpanded(true)
          }}
        >
          展开
          <IconDoubleDown />
        </span>
      )
    }
    return (
      <span
        className="text-ellipsis-expand"
        onClick={e => {
          e.stopPropagation()
          setExpanded(false)
        }}
      >
        收起
        <IconDoubleUp />
      </span>
    )
  }
  return (
    <Typography.Ellipsis
      rows={2} // 需要展示几行
      expanded={expanded}
      //   onExpand={setExpanded}
      expandRender={exp => expandRender(exp)}
    >
      {props.text}
    </Typography.Ellipsis>
  )
}
export default index
